import BaseApiAction from '@Actions/base-api-action';

export default class RemoveSubscriptionFromEntity extends BaseApiAction {
  runAction() {
    let entityType = 'user_id';
    if (this._payload.team_id) entityType = 'team_id';
    if (this._payload.club_id) entityType = 'club_id';

    super.invokeCloudFunction({
      name: 'subscriptions-removeSubscriptionFromEntity',
      payload: {
        subscription_id: this._payload.subscription_id,
        [entityType]:
          this._payload.user_id || this._payload.team_id || this._payload.club_id || null,
      },
    });
  }
}
